import React, { memo } from 'react';
import { Text } from '@chakra-ui/core';

export const SectionLabel = memo(function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <Text fontSize="md" textAlign="left" fontWeight="700" mb={2}>
      {children}
    </Text>
  );
});
